import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeatureGroup } from '../../generic/classes/featuregroup';
import { User } from '../../generic/classes/user';
import { FilterService } from '../../generic/service/filter.service';
import { UserService } from '../../generic/service/user.service';
import { FeatureGroupsComponent } from './featuregroups.component';
import { FilterHeightComponent } from './filter.height.component';
import { FilterSizeComponent } from './filter.potsize.component';
import { FilterPriceComponent } from './filter.price.component';
import { FilterSearchComponent } from './filter.search.component';
import { FilterOrderHistoryComponent } from './filter.order.history';

@Component({
    selector: 'filter-bar',
    styleUrls: ['./filter.component.scss'],
    template: ` <div class="filter-bar">
          <div class="filter-bar__title hide-lg">
            <button class="filter-bar__close" (click)="toggleFilterbar()">
              <svg class="icon-cross-small" width="10" height="10">
                <use
                xlink:href="images/icons/svg-sprite.svg#cross-small"></use>
              </svg>
            </button>
            <span i18n="Label shown for filters@@filterstate.title"
              >Filters</span
              >
            </div>
        
            @if (isOrderHistoryAllowed()) {
              <div>
                @if (!isOrderHistoryActive()) {
                  <div class="filter-bar-part">
                    <button
                      type="button"
                      (click)="toggleHistoryView()"
                      class="button button--secondary button--block theme-btn-primary-outline"
                      i18n="@@reorder.from.history">
                    Re-order from history
                </button>
                  </div>
                }
                @if (isOrderHistoryActive()) {
                  <div>
                    <div class="filter-bar-part filter-bar-part--back-button">
                      <button
                        type="button"
                        (click)="toggleHistoryView()"
                        class="button button--secondary button--block theme-btn-primary-outline"
                        i18n="@@back.to.current.assortment">
                        Back to current assortment
                    </button>
                    </div>
                    <div class="filter-bar-part filter-bar-part--order-history">
                      <filter-order-history
                        i18n-message="@@filterbar.order.history.warning"
                        message="Please note that you are viewing products from your order history.">
                      </filter-order-history>
                    </div>
                  </div>
                }
              </div>
            }
        
            <div class="filter-bar-part hide-md">
              <filter-search></filter-search>
            </div>
        
            @if (userService.isLoggedIn()) {
              <filter-price></filter-price>
            }
        
            <filter-size></filter-size>
        
            <filter-height></filter-height>
        
            <feature-groups [featureGroups]="featureGroups"></feature-groups>
          </div>`,
    standalone: true,
    imports: [
        FilterOrderHistoryComponent,
        FilterSearchComponent,
        FilterPriceComponent,
        FilterSizeComponent,
        FilterHeightComponent,
        FeatureGroupsComponent,
    ],
})
export class FilterBarComponent implements OnInit {
    private filterService = inject(FilterService);
    userService = inject(UserService);
    private activatedRoute = inject(ActivatedRoute);

    @Input() loggedIn: boolean;
    @Input() showFilters: boolean;
    @Input() featureGroups: FeatureGroup[];
    @Output() showFiltersChange = new EventEmitter<boolean>();

    public allowHistoryView: number = 0;

    constructor() {
        this.filterService.initFilterServiceFilterStateForRequestParams(
            this.activatedRoute.snapshot.queryParams,
        );
    }

    isOrderHistoryAllowed(): boolean {
        return this.loggedIn && this.allowHistoryView !== 0;
    }

    getUser(): User {
        return this.userService.getUser();
    }

    ngOnInit(): void {
        if (this.getUser()) {
            this.allowHistoryView = this.getUser().allowHistoryView;
            return;
        }

        this.allowHistoryView = 0;
    }

    isOrderHistoryActive(): boolean {
        return this.filterService.isOrderHistoryActive();
    }

    toggleHistoryView() {
        this.setHistoryView(!this.isOrderHistoryActive(), true);
    }

    setHistoryView(historyViewActive: boolean, clearFilters: boolean) {
        this.filterService.setHistoryView(historyViewActive, clearFilters);
    }

    toggleFilterbar() {
        this.showFilters = !this.showFilters;
        this.showFiltersChange.emit(this.showFilters);
    }
}
